import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useNavigate } from 'react-router';

import { classNames } from '../../../util';
import { Chatbot } from '../../chatbot';
import { Loader } from '../../common/components/Loader';
import { useAnimation } from '../../common/hooks/useAnimation';
import {
  selectChatbotDataLoading,
  selectShouldLoadStartChat,
  selectStartChatError,
  selectStartChatLoading,
} from '../../common/selectors/chat';
import { loadChatbotStartChat } from '../../common/thunks/chatbotStartChat.thunk';
import { experiments } from '../../experiments';
import { appRoutes } from '../../routes';
import { widgetSDK } from '../../sdk/widgetSDK';
import { renderModel } from '../../util/renderModel';
import s from './styles.scss';

const isChatbotDisabled = renderModel.isChatbotDisabled();
const newWidgetExperience = experiments.is('specs.helpwidget.newWidgetExperience', 'true');

export const ChatbotPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const store = useStore();
  const shouldLoadStartChat = useSelector(selectShouldLoadStartChat);
  const error = useSelector(selectStartChatError);
  const startChatLoading = useSelector(selectStartChatLoading);
  // TODO: remove it when specs.helpwidget.newWidgetExperience is merged.
  const chatbotDataLoading = useSelector(selectChatbotDataLoading);
  const activeAnimation = useAnimation(s.moveInRight, s.moveInLeft, []);

  useEffect(() => {
    const load = async () => {
      const context = await widgetSDK.getContext(renderModel.getUserId());
      dispatch(loadChatbotStartChat(context));
    };

    if (newWidgetExperience && !isChatbotDisabled && shouldLoadStartChat) {
      load();
    }
  }, [dispatch, shouldLoadStartChat, newWidgetExperience, isChatbotDisabled]);

  if (isChatbotDisabled) {
    navigate(appRoutes.home());
  }

  if (error) {
    throw new Error('Error loading start chat data');
  }

  if (startChatLoading || chatbotDataLoading) {
    return <Loader height="100%" width="100%" verticalAlign="middle" />;
  }
  return (
    <div className={classNames([s.chatbotContainer, activeAnimation])}>
      <Chatbot store={store} />
    </div>
  );
};
